import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import { Row, Col } from "./Grid";
import Icon from "./Icon";
import Select from "./Select";
import useClientConfig from "../hooks/clientConfigHook";
import { ReactNodeDialog } from "../utils/dialogUtlities";

export const LanguageButton = () => {
    const { t, i18n } = useTranslation();
    const clientConfig = useClientConfig();
    const [lngSetting, setLngSetting] = useState();
    const lng = i18n.resolvedLanguage;
    const languages = useMemo(() => [{ label: 'English', value: 'en' }, ...(clientConfig.additionalLanguages || [])], [clientConfig.additionalLanguages]);

    const handleSave = async (res) => {
        if (res?.lng) {
            localStorage.setItem('lng', res.lng);
            await i18n.changeLanguage(res.lng);
            localStorage.setItem('lng', i18n.language);
        }
        setLngSetting();
    };

    return <>
        <ReactNodeDialog title={t('regionalSettings')} showModal={!!lngSetting} onClose={() => setLngSetting()} onSave={() => handleSave(lngSetting)}>
            <Row>
                <Col>
                    <Select value={lngSetting?.lng} options={languages} placeholder={t('langauge')} labelField="label" valueField="value" onChange={lng => setLngSetting({ lng })}></Select>
                </Col>
            </Row>
        </ReactNodeDialog>
        {languages.length > 1 && <Button className="h-100 border-0 px-2" title={t('language')} style={{ color: 'white', backgroundColor: 'transparent' }} onClick={() => setLngSetting({ lng })}><Icon variant="solid" kind="language"></Icon> <span className="d-inline d-md-none">{t('langauge')}</span></Button>}
    </>;
};
